<div *ngIf="loading" class="loading-content-chart">
  <lib-loading></lib-loading>
</div>

<ng-container *ngIf="!loading"> 
  <h1 class="title-chart">Produtividade da equipe por temperatura de FACs</h1>
  
  <div id="legend">
    <div class="legendValue" *ngFor="let data of chartColors">
      <div class="box-legend" [ngStyle]="{'background-color': data.backgroundColor}"></div>
      <span class="label">{{data.label}}</span>
    </div>
  </div>

  <div class="content-canvas chart">
    <div [ngClass]="{'resize-chart': longest.length <= 10, 'team-name-long': longest.length > 10}">
      <canvas baseChart id="myChart" 
        [ngClass]="{'resize-chart': longest.length <= 10, 'team-name-long': longest.length > 10}"
        (window:resize)="onResize()" [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
        [legend]="false" [chartType]="barChartType" [colors]="chartColors">
      </canvas>
    </div>
  </div>
</ng-container>
